import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-mobile-captcha',
  templateUrl: './mobile-captcha.component.html',
  styleUrls: ['./mobile-captcha.component.scss']
})
export class MobileCaptchaComponent implements OnInit {
  constructor(
    private router: Router,
    private authenService: AuthenticationService,
    private route: ActivatedRoute
    ){
    }
   backgroundUrl:string = '';
   puzzleUrl: string = '';
   tokenVerify: string = '';
   @ViewChild('slider', {static: false}) sliderRef: ElementRef;
   @ViewChild('puzzle', {static: false}) puzzleRef: ElementRef;
   offsetX:number = 0;
   offsetXSuccess: number = 0;
   offsetY: number = 0;
   slideCaptchaOffsetMargin: number = 0;
   dragging: boolean = false;
   backgroundProgress: string = '#d1e9fe';
   borderProgress: string = '1px solid #d1e9fe';
   isVerified: string = '';
   widthCaptcha: number = 0;
   
   ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const width = params['width'];
      this.widthCaptcha = width;
    });
    if (this.widthCaptcha > 0) {
      this.loadCaptcha();
    }
   }
   ngAfterViewInit(): void {
   }
 
   loadCaptcha() {
     this.offsetX = 0;
     this.isVerified = '';
     this.backgroundProgress = '#d1e9fe';
     this.borderProgress = '1px solid #d1e9fe';
     this.authenService.generateCaptcha(this.widthCaptcha).subscribe(res => {
       console.log(res);
       if (res) {
         const dataParse = JSON.parse(res);
         this.backgroundUrl = dataParse.backgroundUrl;
         this.puzzleUrl = dataParse.puzzleUrl;
         this.tokenVerify = dataParse.token;
         this.offsetXSuccess = dataParse.offsetX;
         this.offsetY = dataParse.offsetY;
         this.slideCaptchaOffsetMargin = dataParse.slideCaptchaOffsetMargin;
       }
     })
   }
 
   startDrag(event: MouseEvent | TouchEvent) {
     this.dragging = true;
     const startX = (event instanceof MouseEvent ? event.clientX : event.touches[0].clientX);
     const slider = this.sliderRef.nativeElement;
 
     const move = (moveEvent: MouseEvent | TouchEvent) => {
       const currentX = (moveEvent instanceof MouseEvent ? moveEvent.clientX : moveEvent.touches[0].clientX);
       this.offsetX = Math.max(0, Math.min(currentX - startX, this.widthCaptcha - 50)); // Giới hạn kéo trong phạm vi
     };
 
     const end = () => {
       this.dragging = false;
       document.removeEventListener('mousemove', move as any);
       document.removeEventListener('mouseup', end);
       document.removeEventListener('touchmove', move as any);
       document.removeEventListener('touchend', end);
 
       this.verifyHandleCaptcha();
     };
 
     document.addEventListener('mousemove', move as any);
     document.addEventListener('mouseup', end);
     document.addEventListener('touchmove', move as any);
     document.addEventListener('touchend', end);
   }
 
   verifyHandleCaptcha() {
     if (this.offsetXSuccess - this.slideCaptchaOffsetMargin <= this.offsetX && this.offsetX <= this.offsetXSuccess + this.slideCaptchaOffsetMargin ) {
       this.backgroundProgress = '#D2F4EF';
       this.borderProgress = '1px solid #52CCBA';
       this.isVerified = 'success';
       setTimeout(() => {
         this.verifyCaptcha();
       }, 1000);
     } else {
       this.backgroundProgress = '#f7dcdd';
       this.borderProgress = '1px solid #f35c59';
       this.isVerified = 'error';
       setTimeout(() => {
         this.loadCaptcha();
       }, 1000);
     }
   }
 
   verifyCaptcha() {
     const body = {
       token: this.tokenVerify,
       offsetX: this.offsetX
     }
     this.authenService.verifyCaptcha(body).subscribe(res => {
       let result = JSON.parse(res);
       if (result.success) {
        this.router.navigate(['/enterprise-login'], {
          queryParams: { token: result.token }
        });
       }
     })
   }
}
